import { Injectable } from "@angular/core";
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';

@Injectable()

export class ErrorhandlerService{
    constructor(){}
    handleError(error: HttpErrorResponse) {
        //  if (error.status == Constants.Status_Unauthorized) {
            // alert("Unautorized access Please login again!!!!!!!!!!!");
            //console.error('An error occurred:', error.message);
        //  } else if(error.status == Constants.Status_Internal_Server_Error || error.status == Constants.BAD_REQUEST){
            //alert("Internal Server error Please try again later");
            // console.error('An error occurred:', error.message);
        //    console.error(`Backend returned code ${error.status}, ` +`body was: ${error.error}`);
        //  }
         return throwError(error);
       };
}